import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { COLORS } from '../../../constants/colors.js';
import { CONTAINER_SIZES } from '../../../constants/sizes.js';
import { Spinner } from '../../Spinner/src/Spinner.js';
import modules_5118e2df from '../styles/Button.module.less.js';

/**
 * @description A Button triggers an action or an event
 *
 * @component
 * @example
 * ```jsx
 * <Button variant="primary" color="green" disabled block>
 *   Primary <Icon size="s" icon={<MenuIcon />} />
 * </Button>
 * ```
 */
const Button = React.forwardRef((props, ref) => {
    const { variant, color, size, block, loading, disabled, active, type = 'button', className, children, ...restProps } = props;
    const cx = useStyles(modules_5118e2df);
    const classNames = cx(className, 'container', {
        block,
        loading,
        active,
        [`size-${size}`]: size,
        [`disabled-${variant}`]: disabled || loading,
        [`color-${color}-${variant}`]: true,
    });
    const textClassNames = cx('text');
    return (
    // eslint-disable-next-line react/button-has-type
    React.createElement("button", { "data-qa": "Button", ref: ref, type: type, className: classNames, disabled: disabled || loading, ...restProps },
        React.createElement("span", { className: textClassNames }, children),
        loading && React.createElement(Spinner, { className: cx('spinner') })));
});
Button.defaultProps = {
    variant: 'outlined',
    color: COLORS.DARK,
    size: CONTAINER_SIZES.S44,
    type: 'button',
};
Button.displayName = 'Button';

export { Button };
//# sourceMappingURL=Button.js.map
